// extracted by mini-css-extract-plugin
export default {"tituloAssoolive":"Assoolive_tituloAssoolive__M3ldU","textoAssoolive":"Assoolive_textoAssoolive__Vv-19","textoAssooliveRodape":"Assoolive_textoAssooliveRodape__Ujclo"};